import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";

import styles from "./BioModal.module.scss";
import { useUi } from "@jelly/lesson";

type BioBioModalProps = {
  title: string;
  description: string;
  link?: string;
  linkLabel?: string;
} & Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const BioModal: React.FC<BioBioModalProps> = (props) => {
  const ui = useUi();

  return (
    <ui.Modal {...props} title={props.title}>
      <div className={styles.slide}>
        <div className={styles.content}>{props.description}</div>
        {props.link && (
          <div className={styles.link}>
            <ui.Button size="small" shape={"normal"} theme={"primary"} onClick={() => window.open(props.link)}>
              {props.link || props.linkLabel}
            </ui.Button>
          </div>
        )}
      </div>
    </ui.Modal>
  );
};
